import { AGREEMENT_TYPES, VENDOR_DURACTION_TYPE } from 'domain/finance/vendors/constants';

export default {
  legalEntity: {
    type: 'enum',
    required: true,
  },
  agreementType: {
    type: 'enum',
    required: true,
  },
  durationType: {
    type: 'enum',
    required: true,
  },
  startDate: {
    type: 'date',
    required: true,
  },
  endDate: {
    type: 'date',
    required: {
      value: true,
      when: {
        $durationType: {
          in: [VENDOR_DURACTION_TYPE.ONE_TIME, VENDOR_DURACTION_TYPE.FIXED_TERM],
        },
      },
    },
  },
  publicOfferLink: {
    type: 'string',
    required: {
      value: true,
      when: {
        $agreementType: {
          eq: AGREEMENT_TYPES.PUBLIC_OFFER,
        },
      },
    },
  },
  signedContractAttachment: {
    type: 'array',
    required: {
      value: true,
      when: {
        $agreementType: {
          eq: AGREEMENT_TYPES.CONTRACT,
        },
      },
    },
    maxSize: 1,
  },
};
